import axios from 'axios';

export default class PatientService {
    fetchPatient(patientId) {
        return axios.get(`/v2/patients/${patientId}`);
    }

    updatePatient(patient) {
        return axios.patch(`/v2/patients/${patient.id}`, patient);
    }

    delete(patientId) {
        return axios.delete(`/v2/patients/${patientId}`);
    }

    savePatient(patient) {
        return axios.post('/v2/patients', patient);
    }

    fetchPatientsCount() {
        return axios.get('/v2/patients/count');
    }
}
